import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "print-template" }
const _hoisted_2 = { id: "part1" }
const _hoisted_3 = { style: {"text-align":"center","font-size":"20px","font-weight":"bold"} }
const _hoisted_4 = { style: {"display":"flex","width":"100%"} }
const _hoisted_5 = {
  id: "part2",
  class: "sign-container"
}
const _hoisted_6 = { style: {"display":"flex","width":"100%","margin-top":"100px"} }
const _hoisted_7 = { style: {"position":"relative"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_descriptions_item = _resolveComponent("el-descriptions-item")!
  const _component_el_descriptions = _resolveComponent("el-descriptions")!
  const _component_vxe_column = _resolveComponent("vxe-column")!
  const _component_vxe_table = _resolveComponent("vxe-table")!
  const _component_ZPreview = _resolveComponent("ZPreview")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h3", _hoisted_3, _toDisplayString(_ctx.printDetail.titleDetail.name), 1),
      _cache[0] || (_cache[0] = _createElementVNode("h3", { style: {"text-align":"center","font-size":"20px","font-weight":"bold"} }, "维修报价单", -1)),
      _createElementVNode("div", _hoisted_4, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getPart1Table(), (item, index) => {
          return (_openBlock(), _createBlock(_component_el_descriptions, {
            column: 1,
            style: {"width":"49.5%"},
            key: index
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item, (val, key, index) => {
                return (_openBlock(), _createBlock(_component_el_descriptions_item, {
                  label: key,
                  key: index
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(val), 1)
                  ]),
                  _: 2
                }, 1032, ["label"]))
              }), 128))
            ]),
            _: 2
          }, 1024))
        }), 128))
      ])
    ]),
    _createVNode(_component_vxe_table, {
      border: "",
      "show-footer": "",
      ref: "xTable",
      align: "center",
      class: "mt-20",
      "print-config": _ctx.tablePrint,
      "keep-source": "",
      "auto-resize": "",
      "column-config": { resizable: true },
      "footer-method": _ctx.footerMethod,
      "merge-footer-items": _ctx.mergeFooterItems,
      data: _ctx.tableData
    }, {
      default: _withCtx(() => [
        _createVNode(_component_vxe_column, {
          type: "seq",
          width: "50",
          title: "序号"
        }),
        _createVNode(_component_vxe_column, {
          field: "businessNo",
          title: "编号",
          "min-width": "120"
        }),
        _createVNode(_component_vxe_column, {
          field: "businessName",
          title: "名称",
          "min-width": "120"
        }),
        _createVNode(_component_vxe_column, {
          field: "businessModel",
          title: "型号",
          "min-width": "100"
        }),
        _createVNode(_component_vxe_column, {
          field: "amount",
          title: "数量",
          width: "60"
        }),
        _createVNode(_component_vxe_column, {
          field: "price",
          title: "含税单价",
          "min-width": "100",
          "header-align": "center"
        }, {
          default: _withCtx(({ row }) => [
            _createTextVNode(_toDisplayString(_ctx.$currency(row.price)), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_vxe_column, {
          field: "totalPrice",
          title: "含税总价",
          "min-width": "100",
          "header-align": "center"
        }, {
          default: _withCtx(({ row }) => [
            _createTextVNode(_toDisplayString(_ctx.$currency(row.price * row.amount)), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_vxe_column, {
          field: "businessSerial",
          title: "备注",
          "min-width": "100"
        })
      ]),
      _: 1
    }, 8, ["print-config", "footer-method", "merge-footer-items", "data"]),
    _createElementVNode("div", _hoisted_5, [
      _cache[4] || (_cache[4] = _createElementVNode("h4", { class: "form-title" }, "备注：", -1)),
      _createElementVNode("pre", null, _toDisplayString(_ctx.printDetail.quotationMarkTemplateDetail.mark) + " ", 1),
      _createElementVNode("div", _hoisted_6, [
        _cache[3] || (_cache[3] = _createElementVNode("div", { style: {"width":"49%"} }, [
          _createTextVNode(" 客户代表方签字："),
          _createElementVNode("span", { class: "sign-container-border" })
        ], -1)),
        _createElementVNode("div", _hoisted_7, [
          _cache[1] || (_cache[1] = _createTextVNode(" 业务签字：", -1)),
          _cache[2] || (_cache[2] = _createElementVNode("span", { class: "sign-container-border" }, null, -1)),
          _createVNode(_component_ZPreview, {
            authSrc: _ctx.printDetail.titleDetail.sealImg,
            width: "100px",
            height: "100px",
            class: "upload-file_preview"
          }, null, 8, ["authSrc"])
        ])
      ])
    ])
  ]))
}